import React from 'react';
import moment from 'moment';
export default props => {
  return (
    <ul>
      {props.activities.map(item => {
        const createdDate = moment(item.created * 1000).format(
          'dddd, MM/DD/YYYY hh:mmA'
        );
        return (
          <li key={'activities-' + item.id}>
            {createdDate} - {item.body}{' '}
            {item.external_status !== null && (
              <span>[{item.external_status}]</span>
            )}
          </li>
        );
      })}
    </ul>
  );
};
